import React from "react";
import { useParams } from "react-router-dom";
import resourcesData from "./Resources.json";
import "./ResourceDetail.css";

const CaseStudyDetails = () => {

  const { title } = useParams();

  const caseStudy = resourcesData["Case Study"].find(
    (item) =>
      item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-") === title
  );


  if (!caseStudy) {
    return <h2>Case Study Not Found</h2>;
  }


  const { content } = caseStudy;


  return (
    <div className="backdiv">


      <section className="detail-hero">
          <p className="case-tag">
            CASE STUDY
          </p>

          <h2 className="detail-head">
            {content.heading}
          </h2>
      </section>


      <section className="detail-container">


        <div className="case-block1">

          <h2 className="detail-title d-flex align-items-center justify-content-center">
            Overview
          </h2>

          <p className="main-text">
            {content.overview}
          </p>

        </div>


        <div className="case-block1">

         <div>
            <h2 className="detail-title">
            Business Challenge
          </h2>
 
          <p className="main-text">
            {content.businessChallenge}
          </p>
          </div>
         
          <div className="details-img">
 <img 
          src={caseStudy.img}
          alt={content.heading}
          className="cover-img"
          loading="lazy"
        />
          </div>

        </div>


        <div className="case-block">

             <h2 className="detail-title">
            Our Approach & Solution
          </h2>

         <p className="main-text">
            {content.approachSolution}
          </p>

        </div>

       <div className="case-block">

            <h2 className="detail-title">
            Business & Community Impact
          </h2>

          <p className="main-text">
            {content.impact}
          </p>

        </div>



      </section>


    </div>
  );
};


export default CaseStudyDetails;